import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	excludeAssignee: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.exclude-assignee',
		defaultMessage:
			'Import this field to make sure assignees are displayed in issues, comments, and tags.',
		description: 'Warning message of exclude assignee field',
	},
	excludeDueDate: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.exclude-due-date',
		defaultMessage:
			'Import this field to see your issues in timeline view. <link>Learn more about timeline view</link>',
		description: 'Warning message of exclude due date field',
	},
	excludeStartDate: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.exclude-start-date',
		defaultMessage:
			'Import this field to make sure timeline view is accurate for your project. <link>Learn more about timeline view</link>',
		description: 'Warning message of exclude start date field',
	},
	votesDisableMessage: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.votes-disable-message',
		defaultMessage:
			'To import Likes enable Votes in Settings > System > General Configuration > Options',
		description: 'Steps to enable likes to votes mapping',
	},
	clickupDescriptionRichText: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.clickup-description-rich-text',
		defaultMessage: 'Rich text formatting will not be imported',
		description: 'Warning message of clickup description field',
	},
	clickupStartDateRecurring: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.clickup-start-date-recurring',
		defaultMessage: 'Recurring dates and time will not be imported',
		description: 'Warning message of clickup start date field',
	},
});
